import React from "react";
import { Box, Button, Typography} from "@mui/material";
import { useTranslation } from "react-i18next";

function Acknowledgement({setOpen}) {
    const { t } = useTranslation();

  return (
   <>
    <Box
        component="form" className="login-form"
        >
        <Typography
          variant="mSize"
          component="h5"
          className="font-w-600 line-h-extended-1" sx={{textAlign:'center'}}
        >
         Acknowledgement
        </Typography>
        
          <Box
            sx={{
              width: "100%", margin: "32px 0", padding:"0 38px"
            }}
            className="black-color-2"
            component="div"
          >
           <Typography paragraph variant="sSize" className="font-w-500 line-height-extended-3 gray-color">
           We appreciate your interest in exploring this opportunity, and we are committed to making your visit as informative and enjoyable as possible.
           <Typography component='span' variant="sSize" className="font-w-500 line-height-extended-2 black-color-4"> Our i-Moz agent will get back to you with confirmation of the Visit.</Typography> 
           
           </Typography>
          </Box>
       
       
        <Box
          sx={{ width: "100%", padding: '0 38px' }}
          component="div"
        >
          <Typography paragraph variant="sSize" className="font-w-500 line-height-extended-3 gray-color">
            We look forward to welcoming you and providing you with a comprehensive tour of the property. Our experienced staff will be on hand to answer any questions you may have and to provide you with all the necessary information.
          </Typography>
          <Button
            sx={{
            }}
            className="font-w-600 ack-btn"
          >
            <Typography variant="sSize" component='span' onClick={() => setOpen(false)}> Ok</Typography>
          </Button>
        </Box>
      </Box>
   </>
  )
}

export default Acknowledgement